import moment from "moment";

export const FREE_PLAN_EXTINCTION_DATE = moment('2022-09-20T16:00:00Z');
